// extracted by mini-css-extract-plugin
export default {"wrapper":"FieldWrapper-module--wrapper--TVftA","label":"FieldWrapper-module--label--NlP9K"};